<template>
  <div class="home-container">

    <el-card style="margin-top: 10px;">
      <div class="type-container">
        <div class="type-left">
          <div :class="{'buttons-horizontal': !this.isNavCollapsed, 'buttons-vertical': this.isNavCollapsed}">
            <el-button :style="buttonStyle('video')" @click="selectButton('video')">
              <i class="el-icon-video-camera" style="font-size: 20px"></i>
            </el-button>
            <el-button :style="buttonStyle('picture')" @click="selectButton('picture')" >
              <i class="el-icon-picture-outline" style="font-size: 20px"></i>
            </el-button>
          </div>
<!--          <div style="border-right: 1px solid grey;margin-left: 10px;height: 20px;"></div>-->
          <span class="ttl-tex" style="cursor: pointer;margin-left: 10px" :style="{color:(typeId===0 ? 'blueviolet':'black')}" @click="changeType(0)">全部</span>
        </div>
        <div class="type-item" v-for="item in types">
          <span class="ttl-tex" style="cursor: pointer;" :style="{color:(typeId===item.id ? 'blueviolet':'black')}" @click="changeType(item.id)">{{item.name}}</span>
        </div>
        <div  v-if="!isNavCollapsed" class="type-search">
          <el-input v-model="name" placeholder="请输入内容"></el-input>
          <el-button style="margin-left: 10px;" @click="load">搜索</el-button>
          <el-button style="margin-left: 10px;" type="warning" @click="reset">重置</el-button>
        </div>
      </div>
    </el-card>

    <div class="item-center">
      <div ref="parent" class="parent">
       <el-row :gutter="24">
        <el-col :span="calculateSpan">

          <el-row :gutter="10">
            <el-col :span="6" v-for="item in items" :key="item.id" :class="getImageClass()" style="margin-bottom: 10px">
              <div style="border: 1px solid #ccc; padding-bottom: 10px; border-radius: 10px; overflow: hidden; cursor: pointer" @click="ArClick(item.url,item.id)">
                <img :src="item.img" style="width: 100%; height: 200px; overflow: hidden; border-radius: 10px">
                <div style="color: #000; margin: 10px" class="info">名称:{{ item.name }}</div>
                <div style="margin: 10px;color: #8c939d;" class="info">简介:{{ item.content }}</div>
              </div>
            </el-col>
          </el-row>
          <div style="margin: 10px 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[8 , 16]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>

        </el-col>

        <el-col v-if="!isNavCollapsed" :span="7">

          <el-card>
            <el-carousel height="300px" :interval="10000">
              <el-carousel-item v-for="item in imgs" :key="item">
                <img :src="item" style="width: 100%;height: 100%">
              </el-carousel-item>
            </el-carousel>
          </el-card>

        </el-col>
         <el-col  v-else :span="0">
         </el-col>
      </el-row>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "",
  data() {
    return {
      isNavCollapsed: false, // 控制导航栏是否折叠
      isNavExpanded: false, // 控制下拉菜单是否展开
      parentWidth: window.innerWidth, // 初始宽度，将在mounted中更新
      items:[],
      types:[],
      typeId:0,
      name:'',
      pageNum:1,
      pageSize:8,
      total:0,
      imgs: [
        "http://47.108.174.230:9090/file/33d5d474eb5c4802a107495589af1e7e.jpg",
        "http://47.108.174.230:9090/file/c9cfaa7011aa41dd8301c3e81461349e.jpg",
        "http://47.108.174.230:9090/file/ff9babe6f3d7439ba9e3bbc7e190cb0e.jpg",
      ],
      selectedButton: null,
    };
  },
  created(){this.loadSelection();
    this.load()

    this.loadType()
  },
  mounted() {
    // 页面加载时从localStorage中读取状态
    this.selectedButton = localStorage.getItem('selectedButton') || '';
    window.addEventListener('resize', this.updateParentWidth);
    this.updateParentWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateParentWidth);
  },
  computed: {
    calculateSpan(){
      return this.isNavCollapsed ? 24:17
    },
    // 计算图片列数
    imageColumns() {
      if (this.parentWidth < 350) {
        return 1;
      } else if (this.parentWidth < 750) {
        return 2;
      } else {
        return 4;
      }
    },
    /*filteredData() {
      // 如果选中了视频按钮，筛选url不为空的数据
      if (this.selectedButton === 'video') {//.filter(item => item.url)
        return this.items.slice().reverse();
      }else if(this.selectedButton === 'picture'){
        return this.items.filter(item => !item.url);
      }else {// 否则返回所有数据
        return this.items;}


    }*/
  },
  methods:{
    handleNavClick(item) {
      // 处理导航按钮点击事件
      console.log(`Clicked: ${item.label}`);
      // 如果需要关闭下拉菜单，可以在这里设置 isNavExpanded = false;
    },
    updateParentWidth() {
      this.parentWidth = this.$refs.parent.offsetWidth;
      this.checkNavCollapse();
    },
    checkNavCollapse() {
      this.isNavCollapsed = this.parentWidth < 500;
    },
    getImageClass() {
      const baseClass = 'image-item';
      const sizeClass = `image-item-${100 / this.imageColumns}`; // 根据列数计算宽度百分比
      return `${baseClass} ${sizeClass}`;
    },
    selectButton(buttonType) {
      this.selectedButton = buttonType;
      this.saveSelection();
      window.location.reload();
    },

    buttonStyle(buttonType){
      // 如果当前按钮被选中，则更改其背景颜色
      if (this.selectedButton === buttonType) {
        return {
          margin: 0,
          fontSize: '20px',
            width: '100%',
          height:'100%',
            backgroundColor: '#000000', // 更深的背景色
          color: '#FFFFFF', // 考虑到背景色变深，字体颜色改为白色以便阅读
        };
      }

      // 否则保持原样
      return {
        margin: 0,
        fontSize: '20px',
        width: '100%',
        height:'100%',
        backgroundColor: '#FFFFFF', // 默认背景色
        color: '#000000', // 默认字体颜色
      };

    },
    saveSelection() {
      localStorage.setItem('selectedButton', this.selectedButton);
    },
    loadSelection() {
      const savedSelection = localStorage.getItem('selectedButton');
      if (savedSelection) {
        this.selectedButton = savedSelection;
      }
    },
    ArClick(url,id) {
      // 判断url是否为空
      if (!url || url.trim() === '') {
        this.$router.push('/front/clothingDetail?id='+id);
      } else {
        this.$router.push('/front/Video?url='+url);
        //this.goToUrl(url);
      }
    },
    load(){
      let url = '/clothing/front/page'; // 默认请求/clothing/front/page
      // 根据selectedButton的值调整请求URL
      if (this.selectedButton === 'video') {
        url = '/clothing/front/video/page';
      }
      this.request.get(url,{
        params:{
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          name:this.name,
          typeId:this.typeId
        }
      }).then(res=>{
        if(res.code==='200'){
          this.items=res.data?.records || []
          this.total=res.data?.total || 0
        }
      })
      /*this.request.get("/clothing/front/page",{
        params:{
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          name:this.name,
          typeId:this.typeId
        }
      }).then(res=>{
        if(res.code==='200'){
          this.items=res.data?.records || []
          this.total=res.data?.total || 0
        }
      })*/
    },
    changeType(id) {
      this.typeId = id
      this.load()
    },
    loadType(){
      this.request.get("/type").then(res=>{
        this.types=res.data
      })
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum
      this.load()
    },
    reset(){
      this.name=''
      this.typeId=0
      this.load()
    }
  }
};
</script>

<style lang="scss" scoped>


.buttons-horizontal {
  display: flex;
  flex-direction: row; /* 横向排列 */
}

.buttons-vertical {
  display: flex;
  flex-direction: column; /* 纵向排列 */
}
.image-item {
  box-sizing: border-box;
  padding: 10px;
}

.image-item-25 {
  width: 25%;
}

.image-item-50 {
  width: 50%;
}

.image-item-100 {
  width: 100%;
}
.ttl-tex {
  font-family: 华文中宋;
  font-size: 18px;
  color: #000000;
}
.info{
  height: 15px;
  line-height: 1.2;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 这里是超出几行省略 */
  overflow: hidden;
}

.home-container {
  width: 70%;
  margin: 0 auto;
  .type-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .type-left{
      flex: 1;
      display: flex;
      align-items: center;
    }
    .type-item{
      flex: 1;
      text-align: center;
    }
    .type-search{
      display: flex;
    }
  }
  .item-center{
    .el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      margin: 10px 0;
    }
    margin-top: 20px;
  }
}
</style>
